import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../components/AuthContext';
import apiUrl from '../constants/ApiUrls';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
`;

const FormContainer = styled.div`
  background-color: #ffffff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  width: 100%;
`;

const Logo = styled.h1`
  font-size: 2rem;
  color: #007bff;
  margin: 0 0 10px 0;
`;

const Instruction = styled.p`
  margin-bottom: 20px;
  color: #6c757d;
`;

const Title = styled.h2`
  font-size: 1.5rem;
  margin: 10px 0;
`;

const InputContainer = styled.div`
  position: relative;
  margin-bottom: 20px;
`;

const Input = styled.input`
  width: 90%;
  padding: 10px 10px 10px 10px;
  border-radius: 4px;
  border: 1px solid #ced4da;
`;

const Icon = styled.span`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
`;

const Button = styled.button`
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  border: none;
  background-color: #007bff;
  color: #ffffff;
  font-size: 1rem;
  cursor: pointer;
`;

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    try {
        const response = await axios.post(`${apiUrl}/auth/login`, { email, password });
      const { token, user } = response.data.data;
      localStorage.setItem('authToken', token);
      localStorage.setItem('userId', user.id);
      login();
      navigate('/delete-account');
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <Container>
      <FormContainer>
        <Logo>AU<text style={{color:'#FF9228'}}>NE</text></Logo>
        <Instruction>Veuillez remplir les champs ci-dessous pour vous connecter</Instruction>
        <Title>Connexion</Title>
        <form onSubmit={handleSubmit}>
          <InputContainer>
            <Input
              type="email"
              placeholder="Adresse email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Icon>📧</Icon>
          </InputContainer>
          <InputContainer>
            <Input
              type="password"
              placeholder="Mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Icon>🔒</Icon>
          </InputContainer>
          <Button type="submit">Se connecter</Button>
        </form>
      </FormContainer>
    </Container>
  );
};

export default Login;
